import React, { ReactNode } from "react";

export interface IconProps {
	classes?: string;
	icon: string;
	type?: "light" | "regular" | "solid" | "brand" | "duotone";
	badge?: number;
	onClick?: (event: React.MouseEvent) => void;
	children?: ReactNode;
}

const Icon: React.FC<IconProps> = ({ classes = "", children, icon, type, badge, onClick }) => {
	const weight = type ? type.substring(0, 1) : "l";
	return (
		<>
			<i className={`fa${weight} fa-${icon} ${classes}`} onClick={onClick}></i>
			{badge && <div className="badge">{badge}</div>}
		</>
	);
};

export default Icon;
